<template>
<!-- 推广管理 -->
    <div class="el-card pd20">
        <div class="main">
            <div class="box">
                <!--  --> 
                <div class="search">
                    <div class="search-gropu">
                        转化营类型
                        <el-select class="search-child"  v-model="obj.buy_id" placeholder="请选择转化营类型" clearable v-if="!buy_list.length">
                            <el-option label="9.9转化营3" :value="6"></el-option>
                            <el-option label="9.9转化营2" :value="5"></el-option>
                            <el-option label="9.9转化营" :value="1"></el-option>
                            <el-option label="9.9转化营-新媒体" :value="4"></el-option>
                            <el-option label="0.01转化营-新媒体" :value="2"></el-option>
                            <el-option label="9.9转化营-KOL" :value="3"></el-option>
                        </el-select>
                        <el-select class="search-child"  v-model="obj.buy_id" placeholder="请选择转化营类型" clearable v-else>
                            <el-option :label="item.remark" :value="item.id" v-for="item in buy_list" :key="item.id"></el-option>
                        </el-select>

                        &nbsp;&nbsp;&nbsp;&nbsp;付款时间：
                        <el-date-picker
                          v-model="timerange"
                          type="datetimerange"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    <el-button type="primary" @click="pullData" size="medium">搜索</el-button>
                </div>
            
            </div>
            <!-- list-->
            <div class="el-card pd20">
                <el-table :data="list" show-overflow-tooltip border style="width: 100%">
                    <el-table-column type="index" width="50" label="序号"></el-table-column>
                    <el-table-column  label="支付金额">
                        <template  slot-scope="scope">
                            <div>
                            {{(scope.row.pay_price/100)+'元'}}
                            </div>
                        </template>
                    </el-table-column>
                    </el-table-column>
                    <el-table-column prop="create_time" label="创建时间" > </el-table-column>
                    <el-table-column prop="pay_time" label="付款时间"></el-table-column>
                    <el-table-column prop="wxnum" label="微信单号" > </el-table-column>
                    <el-table-column prop="remark" label="备注" > </el-table-column>
                </el-table>
            </div>
            
            <!-- 分页 -->
            <el-pagination class="pages" 
                :page-sizes="[25, 50, 75, 100]"
                @size-change="handleSizeChange" 
                @current-change="handleCurrentChange" 
                :page-size="pages.size" 
                :current-page="pages.page"
                background 
                layout="sizes,prev, pager, next" 
                :total="pages.count"> 
            </el-pagination>
            <!-- -->
        </div>
    </div>
</template>

<script>
import { buyList, orderList} from "@/api/extension";
export default {
    data() {
        return{
            list: [],
            pages: {},
            obj:{
                buy_id: 6
            },
            buy_list: [],
            timerange: null
        }
    },
    methods:{
         // 调整每页显示条数
        handleSizeChange(val) {
            this.pages.size = val;
            this.pullData();
        },
        // 触发分页
        handleCurrentChange(val) {
            this.pages.page = val;
            this.pullData();
        },
        pullData(){
            this.$showLoading();
            this.obj = {
                page:Object.keys(this.pages).length>0?this.pages.page:1,  //页码，默认1
                size:Object.keys(this.pages).length>0?this.pages.size:25,   //每页数量，默认25
                buy_id:this.obj.buy_id  //每页数量，默认25
            };

            if(this.timerange && this.timerange[0]) {
                this.obj.pay_time_start = this.timerange[0];
            }
            if(this.timerange && this.timerange[1]) {
                this.obj.pay_time_end = this.timerange[1];
            }

            orderList(this.obj).then((data)=>{
                this.list = data.list;
                this.pages = data.pager;
                
                this.$hideLoading();
            }).catch((err)=>{
                this.$hideLoading();
            });
            
        },
    },
    mounted() {
        buyList().then(data => {
            this.buy_list = data.list;
        });
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.main{
  position: relative;
}
.addBtn{
  position: absolute;
  left: 0;
  bottom: 0;
}
.pages{
  text-align: right;
  margin-top: 30px;
}
.pages-box{
    height: 32px;
    margin-top: 30px;
}
.preview{
    width: 300px;
    border-radius: 5px;
}
.box{
    margin-bottom: 20px;
}
.search{
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
}
.search.search-btn{
    flex: 1;
}
.search-gropu{
    flex: 1;
}
.search-gropu.on{
    flex: 1.5;
}
.search-child{
    margin-left: 20px;
    width: 200px;
}
.userinfo{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    img{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 15px;
    }
}
.el-input{
    width:200px;
}
</style>